$(window).on('scroll', function() {
  $(".radius-image__content").each(function() {
    if (isScrolledIntoView($(this))) {
      // console.log($(this))
    }
  });
});

function isScrolledIntoView(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();

  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height();

  return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

// Videos
const videos = [
  {
    containerId: 'landing-video',
    videoId: 'hhLE_mdSZm8'
  },
  {
    containerId: 'mobile-communities-video',
    videoId: 'm_rL6G4Bhnw'
  },
  {
    containerId: 'mobile-innovation-video',
    videoId: 'jhdbWIEI6tc'
  },
  {
    containerId: 'mobile-partnership-video',
    videoId: '0uBsomN7hOo'
  },
  {
    containerId: 'desktop-communities-video',
    videoId: 'm_rL6G4Bhnw'
  },
  {
    containerId: 'desktop-innovation-video',
    videoId: 'jhdbWIEI6tc'
  },
  {
    containerId: 'desktop-partnership-video',
    videoId: '0uBsomN7hOo'
  },

]

const players = {

}

function getYTInstance (video) {
  new window.YT.Player(video.containerId, {
    videoId: video.videoId,
    playerVars: {
      playsinline: 1,
      rel: 0,
    },
    events: {
      'onReady': (event) => {
        players[video.containerId] = event.target
      }
    }
  })
}

window.onYouTubeIframeAPIReady = function () {
  for (let i = 0; i < videos.length; i++) {
    const video = videos[i]
    if (document.querySelector('#' + video.containerId)) {
      players[video.containerId] = getYTInstance(video)
    }
  }
}

function playVideo(containerId) {
  if (players[containerId]) {
    players[containerId].playVideo()
  } else {
    setTimeout(function() {
      playVideo(containerId)
    }, 100)
  }
}

// Toggling Class
$('[data-toggle]').on('click', function togglingClass() {
  const targetId = $(this).data('toggle');
  const targetElem = $('[data-toggle-target="' + targetId + '"]');
  const toggleClass = targetElem.data('toggle-class');
  const callbackPlayVideo = targetElem.data('callback-playvideo');
  const postToggleClass = targetElem.data('toggle-class-post');
  const bodyToggleClass = targetElem.data('toggle-class-body');
  if (postToggleClass === 'invisible') {
    if (targetElem.hasClass(postToggleClass)) {
      targetElem.removeClass(postToggleClass)
    } else {
      setTimeout(() => {
        targetElem.addClass(postToggleClass)
      }, 300)
    }
  }
  if (bodyToggleClass) {
    const targetElemBoby = $('body');
    if (targetElemBoby.hasClass(bodyToggleClass)) {
      targetElemBoby.removeClass(bodyToggleClass)
    } else {
      setTimeout(() => {
        targetElemBoby.addClass(bodyToggleClass)
      }, 100)
    }
  }
  targetElem.toggleClass(toggleClass)
  if (callbackPlayVideo) {
    playVideo(callbackPlayVideo)
  }
})

// Tabs
$('[data-tabs]').each(function tabContentIterator() {
  const tabsContainer = $(this);
  const tabId = tabsContainer.data('tabs');
  const tabsContentContainer = $('[data-tabs-content="' + tabId +  '"]')
  const highlightColorClass = tabsContainer.data('tab-highlight-color')
  $(this).find('> div').on('click', function toggleTab() {
    for (let i = 0; i < tabsContainer.find('> div').length; i++) {
      let tempBgClass = ''
      tabsContainer.find('> div')[i].classList.forEach(
        function(value) {
          if (value.includes('bg-')) tempBgClass = value
        },
      );
      if (tempBgClass) tabsContainer.find('> div')[i].classList.remove(tempBgClass)
    }
    let currentClassDataBg = this.dataset['tabHighlightColor'] || highlightColorClass || 'bg-primary-purple-300'
    const index = $(this).data('tab-index');
    tabsContainer.find('> div').removeClass(currentClassDataBg)
    tabsContainer.find('> div').removeClass('text-white')
    $(this).addClass(currentClassDataBg)
    $(this).addClass('text-white')
    tabsContentContainer.find('> div').css('display', 'none')
    tabsContentContainer.find('[data-tab-index="' + index + '"]').css('display', 'flex');
  })
  $(this).find('> div:first-child').click();
})
